export {data};

import API_URL from '../../includes/api.js';
import {resolveTenantData} from '../../tenant/site-configs.js';
import {fetchApiJson, refererHeaders} from '../../includes/server-fetch.js';

// Mirrors Network.jsx's mount-time fetches so content is present before hydration;
// swiper carousel behavior itself stays client-only.
//
// +data.shared.js is NOT cumulative in Vike — this page-level file replaces the root
// one, so it must resolve+spread tenant data itself or lose messages/faq/about.
async function data(pageContext) {
    const tenantData = resolveTenantData(pageContext);
    const headers = refererHeaders(pageContext);

    // Network.jsx's client-side fetch still retries after hydration, so failed fetches
    // fall back to [] here (unlike other +data.shared.js files, this doesn't distinguish "failed" from "empty").
    const [networkResult, subscribersResult] = await Promise.all([
        fetchApiJson(`${API_URL}/member/network`, headers, pageContext),
        fetchApiJson(`${API_URL}/subscriber/getsubscriberssite`, headers, pageContext),
    ]);

    return {
        ...tenantData,
        networkData: networkResult.data ?? [],
        subscribers: subscribersResult.data ?? [],
    };
}
